import get from "lodash.get";

export const mapFeatures = preferences => {
  const featureMap = get(preferences, "settings.FeatureManagement", {});
  return Object.entries(featureMap).map(([name, value]) => ({
    name,
    value: value === "true"
  }));
};
